<template>
  <div id="tranAm">
<!--    <div class="bg-color-black">-->
      <div class="d-flex pt-2 pl-2" style="justify-content: space-between;align-items: center;">
         <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">专家团队名录</span>
        </span>
        <span @click="dialogVisible = true" style="font-size: 0.2rem;color: #ffffff;cursor: pointer;">更多+</span>
        <el-dialog title="专家团队名录" :visible.sync="dialogVisible" width="80%" center>
          <el-table :data="dataList" style="width: 95%;margin: 0 auto;" :header-cell-style="{background:'#043B95',color:'#fff','text-align':'center',}"
                    :row-style="{background:'#043B95',color:'#fff'}">
            <el-table-column label="序号" :index="indexMethod" type="index" width="60px" align="center">
<!--              <template slot-scope="scope">-->
<!--                <span>{{ scope.$index + 1 }}</span>-->
<!--              </template>-->
            </el-table-column>
            <el-table-column prop="teamName" label="团队名称" align="center">
            </el-table-column>
<!--            <el-table-column label='人才类别' prop='rencaiTypeDisplay' align="center">-->
<!--&lt;!&ndash;              <template slot-scope="scope">&ndash;&gt;-->
<!--&lt;!&ndash;                {{ scope.row.enterpriseType==1?'科技性企业':scope.row.enterpriseType==2?'科技型企业(入库)':'高新技术企业' }}&ndash;&gt;-->
<!--&lt;!&ndash;              </template>&ndash;&gt;-->
<!--            </el-table-column>-->
            <el-table-column prop="company" label="所属单位" align="center">
            </el-table-column>
<!--            <el-table-column prop="industryList" label="所属行业" align="center">-->
<!--              <template slot-scope="scope">-->
<!--                {{ scope.row.industryList[0].industryName }}-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="applicationTime" label="申报时间" width="180" align="center">
                            <template slot-scope="scope">
                              {{ scope.row.applicationTime }}年
                            </template>
            </el-table-column>
<!--            <el-table-column prop="post" label="现任职务" width="180" align="center">-->
<!--            </el-table-column>-->
<!--            <el-table-column label='操作' align="center">-->
<!--              <template slot-scope='scope'>-->
<!--                <a @click="getDetail(scope.row.id)" style="color: #5cd9e8;cursor: pointer;">详情</a>-->
<!--              </template>-->
<!--            </el-table-column>-->


          </el-table>
          <el-pagination background :total='total' :current-page.sync='searchForm.pageNum' :page-size='searchForm.pageSize' @current-change='pageChange' class='pagination'
                         layout='prev, pager, next'></el-pagination>
        </el-dialog>
<!--        <el-dialog title="人才信息" :visible.sync="dialogFormVisible" width="80%" center :show-close="false">-->
<!--          <a @click="goto" style="color: #5cd9e8;font-size: 16px;float: right;line-height: 40px;margin-top: -40px;cursor: pointer;">-->
<!--            ◀ 返回列表</a>-->
<!--          <h2 style="color: #fff;height: 40px;text-align: center;clear: both;">{{ detail.rencaiName}}</h2>-->
<!--          <table class="Sta_table_one1" style="width: 90%;color: #fff;margin: 0 auto;">-->
<!--            <thead>-->
<!--            <tr>-->
<!--              <td style="width: 140px;"></td>-->
<!--              <td style="width: 220px;"></td>-->
<!--              <td style="width: 100px;"></td>-->
<!--              <td style="width: 270px;"></td>-->
<!--              <td style="width: 100px;"></td>-->
<!--              <td></td>-->
<!--            </tr>-->
<!--            </thead>-->
<!--            <tbody>-->
<!--            <tr>-->
<!--              <td>人才类别</td>-->
<!--              <td>{{ detail.rencaiTypeDisplay }}</td>-->
<!--              &lt;!&ndash; <td>经营状态</td>-->
<!--              <td>存续</td> &ndash;&gt;-->
<!--              <td>职称</td>-->
<!--              <td>{{ detail.jobTitle}}</td>-->
<!--              <td>所属单位</td>-->
<!--              <td>{{ detail.company }}</td>-->
<!--            </tr>-->
<!--            <tr>	<td style="display: inline-block;">现任职务</td>-->
<!--              <td>{{ detail.post }}</td>-->
<!--              <td>所属行业</td>-->
<!--              <td colspan="3">{{ detail.industryList?detail.industryList[0].industryName:'-' }}</td>-->

<!--            </tr>-->
<!--            <tr>-->

<!--              <td>所属地区</td>-->
<!--              <td>{{ detail.areaDisplay}}</td>-->
<!--              <td>擅长领域</td>-->
<!--              <td colspan="3">{{ detail.servicesList?detail.servicesList[0].servicesName : '-' }}</td>-->
<!--            </tr>-->
<!--&lt;!&ndash;            <tr>&ndash;&gt;-->
<!--&lt;!&ndash;              <td>地区</td>&ndash;&gt;-->
<!--&lt;!&ndash;              <td>{{ detail.areaDisplay }}</td>&ndash;&gt;-->
<!--&lt;!&ndash;              <td>地址</td>&ndash;&gt;-->
<!--&lt;!&ndash;              <td colspan="3">{{ detail.address }}</td>&ndash;&gt;-->
<!--&lt;!&ndash;            </tr>&ndash;&gt;-->
<!--            <tr>-->
<!--              <td>人才介绍</td>-->
<!--              <td colspan="5" style="text-align: left;">-->
<!--                {{ detail.rencaiDsc }}-->
<!--              </td>-->
<!--            </tr>-->
<!--            </tbody>-->
<!--          </table>-->
<!--        </el-dialog>-->
      </div>
      <div class="d-flex jc-center body-box" style=" margin-top: 0.5rem;width:100%;height:90%;padding-bottom: 0.1rem">
        <!--        <dv-scroll-board :config="config" style="width:100%;height: 3rem" />-->
        <dv-scroll-board :config="config" @click="row" style="width:100%;height:100%" />
      </div>
    </div>
<!--  </div>-->
</template>
<!-- import JavaScript -->

<script>
import sciApi from '@/api/index.js'
// import $ from 'jquery'
export default {
  data() {
    return {
      dialogVisible: false,
      dialogFormVisible: false,
      videoUrl:'',
      dataList:[],
      total: 0,
      searchForm: {
        pageSize:10,
        pageNum:1
      },
      detail: {},
      tum:[],
      config: {
        header: ['<span style="font-weight: bold">团队名称</span>','<span style="font-weight: bold">所属单位</span>','<span style="font-weight: bold">申报时间</span>'],
        data: [
          // ['唐洪兵','农业教育','高级农艺师','区农委'],
          // ['蔡家军','农学','高级农艺师','区农委'],
          // ['曾仁甫','淡水渔业养殖','水产工程师','区水产技术推广站'],
          // ['杨龙','淡水养殖','水产高级工程师师','区农委'],
          // ['何清中','农学','高级农艺师','区农业技术推广服务中心'],
          // ['王友文','农学','高级农艺师','区农业技术推广服务中心'],
          // ['吴思华','植保','高级农艺师','区农委'],
          // ['陈正明','农业工程','教授','市农科院'],
        ],
        headerHeight:50,
        rowNum:4,
        headerBGC:'rgba(51, 109, 233, 0.5)',
        evenRowBGC:'rgba(51, 109, 233, 0)',
        oddRowBGC:'rgba(51, 109, 233, 0.2)',
        align: ['center','center','center','center'],
        columnWidth: [220,220,100],
      },

    };
  },

  computed: {
    indexMethod() {
      return (this.searchForm.pageNum - 1) * (this.searchForm.pageSize) + 1
    }
  },
  created() {
  },
  mounted() {
    this.init().then(()=>{
      this.config ={ header: ['<span style="font-weight: bold">团队名称</span>','<span style="font-weight: bold">所属单位</span>','<span style="font-weight: bold">申报时间</span>'],
        // data:this.tum,
        data:this.tum,
        headerHeight:50,
        rowNum:4,
        headerBGC:'rgba(51, 109, 233, 0.5)',
        evenRowBGC:'rgba(51, 109, 233, 0)',
        oddRowBGC:'rgba(51, 109, 233, 0.2)',
        align: ['center','center','center'],
        columnWidth: [220,220,100],
      }
    })
  },
  methods: {
    async init() {
      await sciApi.selectRenCaiList(
          this.searchForm
      ).then((data) => {
        this.dataList = data.list || []
        this.total=data.total
        this.dataList.forEach((item) => {
          let num = []
          // num.push(item.rencaiName)
          // num.push(item.rencaiTypeDisplay?item.rencaiTypeDisplay:'-')
          num.push(item.teamName)
          num.push(item.company)
          num.push(item.applicationTime+'年')
          num.push('<span style="display:none">'+ item.id + '</span>')
          // num.push(item.totalPrices)
          this.tum.push(num)

        })


      })
    },
    pageChange() {
      this.init();
    },
    row(val){
      console.log(val,'val')
      var id=val.row[4].replace(/[^0-9]/ig,"")
      this.getDetail(id);
    },
    goto() {
      this.dialogVisible = true
      this.dialogFormVisible = false
    },
    async getDetail(id) {
      this.detail = []
      await sciApi.renCaiDetail({
        id: id
      }).then((data) => {
        this.detail = data
        this.dialogVisible = false
        this.dialogFormVisible = true
      })
    }
  }
};
</script>


<style lang="scss">
.el-table--border::after {

  width: 0px;
}
.gutter{
  display:block!important ;
}
.el-table__header-wrapper{
  background:none;
}
.el-pagination{
  margin-top: 30px;
  text-align: center;
}
// .el-pagination.is-background .el-pager li:not(.disabled).active {
// background-color: rgba(4,59,149,0.8);
// }
.Sta_table_one1 tbody tr td:nth-child(2n-1) {
  background: rgba(4,59,149,0.8);
  color: #3FCAFA;
  vertical-align: middle;
}
.Sta_table_one1 tbody tr td {
  background: rgba(4,59,149,0.8);
  border: 1px solid rgba(38,111,232,0.5);
  padding: 10px;
  font-size: 16px;
  line-height: 24px;
}
#tranAm {
  padding: 0.2rem;
  width: 100%;
  height: 100%;

  //border-radius: 0.0625rem;
  .bg-color-black {
    padding: 0.0625rem;
    height: 4.5rem;
    border-radius: 0.125rem;
  }

  .text {
    color: #c3cbde;
  }

  .body-box {
    //border-radius: 0.125rem;
    overflow: hidden;
  }

  .head {
    background: rgba(255, 255, 255, 0.1);
    font-size: 18px;
    padding: 0.2rem;
    color: #68d8fe;
    display: flex;
    justify-content: space-between;
    line-height: 1.05;
  }

  .slideBox ul li {
    line-height: 36px;
    height: 36px;
    font-size: 16px;
    color: #4c9bfd;
    //padding: 0 0.2rem;
  }

  .slideBox ul li a {
    color: #4c9bfd !important;
    line-height: 40px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    width: 33%;
    text-align: left;
    float: left;
  }

  .slideBox ul li p {
    text-align: center;
    color: #4c9bfd !important;
    line-height: 40px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    width: 33%;
    float: left;
  }

  .slideBox ul li span {
    float: right;
    line-height: 40px;
    padding-right: 0.1rem;
  }
}

.el-dialog {
  background: rgba(51, 109, 233, 0.5) !important;
  color: #fff !important;
}

.el-dialog__title,
.el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
  font-size: 0.25rem !important;
}

.el-table__body tr.current-row>td {
  background: #3FCAFA !important;
}

.el-table td,
.el-table th.is-leaf,
.el-table td,
.building-top .el-table th.is-leaf {
  border-bottom: 1px solid rgba(38, 111, 232, 0.5);
  // border-right: 1px solid #5cd9e8!important;
}

.el-table::before {
  border-color: rgba(38, 111, 232, 0.5);
  display: none !important;
}

// .el-table--border  td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {

// }
.el-table__body tr.current-row>td,
.el-table--enable-row-hover .el-table__body tr:hover>td {
  background: none !important;
}
</style>
